export default __webpack_public_path__ + "static/media/renters-white.500ef8f2.svg";